// extracted by mini-css-extract-plugin
module.exports = {"ranking":"home_ranking__3T2Gr"};